// consoleControl.js
//
// Silences noisy console output (log/debug/info) when the build's
// REACT_APP_DISABLE_CONSOLE flag is set to "1". Controlled per environment
// via the matching .env file, so suppression can be rolled out one
// environment at a time (local -> staging -> production).
//
// console.warn and console.error are intentionally left intact so real
// problems remain visible in every environment.
export function suppressConsoleInProduction() {
  if (process.env.REACT_APP_DISABLE_CONSOLE === "1") {
    const noop = () => {};
    console.log = noop;
    console.debug = noop;
    console.info = noop;
    console.warn = noop;
  }
}
